import { LitElement, html, svg } from 'lit';

export class IconClock32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Klokke</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" d="M16 8v10l6.667 3.333"></path><path stroke="currentColor" stroke-miterlimit="10" stroke-width="1.5" d="M16 31c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C7.716 1 1 7.716 1 16c0 8.284 6.716 15 15 15Z"></path></svg>`; }
}
if (!customElements.get('f-icon-clock32', IconClock32)) {
  customElements.define('f-icon-clock32', IconClock32);
}